'use client';

import Script from 'next/script';

import { GA_MEASUREMENT_ID } from '@/app/lib/analytics';

/**
 * Loads the GA4 gtag.js library and initialises the data layer.
 *
 * `send_page_view: false` — pageviews are emitted centrally by
 * <AnalyticsListener/> so that client-side (soft) navigations are captured and
 * not double-counted. Renders nothing when no measurement ID is configured.
 */
export default function GoogleAnalytics() {
  if (!GA_MEASUREMENT_ID) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
        async
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', { send_page_view: false });
        `}
      </Script>
    </>
  );
}
